import React from 'react';
import './qualify-box.scss';


const QualifyBox = ({ title, child, isTitleVisible = true }) => {
  return (
    <div className="f-qualify-box" >
        <h3 className={isTitleVisible ? "f-qualify-box-title" : "f-qualify-box-title--hidden"}>{title}</h3>
        {child}
    </div>
  )
}

export default QualifyBox;